import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import Hero from '../../sections/Hero';
import ServicesOverview from '../../sections/ServicesOverview';
import WhyChooseUs from '../../sections/WhyChooseUs';
import AboutSection from '../../sections/AboutSection';
import RecentProjects from '../../sections/RecentProjects';
import TestimonialsSection from '../../sections/TestimonialsSection';
import ServiceAreaMap from '../../sections/ServiceAreaMap';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Junk Removal, Moving & Delivery in Green Bay, WI</title>
        <meta
          name="description"
          content="Junk removal, moving and delivery in Green Bay, the Fox Valley and Door County. Local crew, free quotes, junk removal from $100. Call (920) 255-8952."
        />
        {/* Schema.org markup for services */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": ["Junk Removal", "Moving Company", "Delivery Service"],
            "provider": {
              "@type": "MovingCompany",
              "name": "JBR Delivery LLC",
              "areaServed": {
                "@type": "Place",
                "name": "Northeast Wisconsin and Door County"
              },
              "telephone": "(920) 255-8952"
            },
            "areaServed": {
              "@type": "Place",
              "name": "Northeast Wisconsin and Door County"
            },
            "description": "Professional moving company, delivery, and junk removal services in Northeast Wisconsin, including Green Bay, Door County, and Appleton. Fast, reliable, and affordable solutions."
          })}
        </script>
      </Helmet>

      <Box component="section">
        <Hero />
      </Box>

      <Box component="section">
        <ServicesOverview limitServices={3} />
      </Box>

      <Box component="section">
        <WhyChooseUs />
      </Box>

      <Box component="section">
        <AboutSection />
      </Box>

      <Box component="section">
        <RecentProjects />
      </Box>

      <Box component="section">
        <TestimonialsSection />
      </Box>

      <Box component="section">
        <ServiceAreaMap />
      </Box>

      <Box component="section">
        <QuoteRequestForm />
      </Box>
    </>
  );
};

export default HomePage;
